import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getOfficesList } from 'modules/settings/api';

export const useQueryOfficesList = () => useQuery([QUERY_KEYS.RENTALS_OFFICES], getOfficesList);
